import { ExternalDashboardsComponent } from './external-dashboards.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const externalDashboardsRoutes: Routes = [
  {
    path: 'external-dashboards',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: ExternalDashboardsComponent }],
  },
]
